module.exports = __webpack_public_path__ + "static/media/lightbox_delete_icon.d1b7ef72.svg";